import { bookingInquiryApis } from '@apis/bookingInquiryApis';
import { useMutation } from '@hooks/useMutation';
import { PostBookingInquiryDraft } from '@models/BookingInquiryDraft';

export const usePostBookingInquiryDraft = () => {
  return useMutation(async (body: PostBookingInquiryDraft) => {
    return await bookingInquiryApis.post('/booking-inquiry-draft/', {
      body,
    });
  });
};
